import * as ApiManager from './_manager';
import store from '@/store';

export const company = {
  list: payload => {
    return ApiManager.callApi ('/guest/company/list', payload);
  },
  get: payload => {
    return ApiManager.callApi (
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/get`,
      payload
    );
  },

  initByDomain: payload => {
    return ApiManager.callApi (
      `/guest/company/get`,
      payload
    );
  },

  listPaymentGateways : payload => {
    return ApiManager.callApi (
        `/guest/company/${store.getters['company/getCurrentCompanyId']}/listPaymentGateways`,
         payload
    );
  },

  checkCompanyAuth : payload => {
    return ApiManager.callApi (
      `/guest/company/get-logged-session`,
        payload
    );
  },
};
